import React, { useContext, useState } from "react";
import "./orgInfo.css";
import {
  Grid,
  TextField,
  Checkbox,
  NativeSelect,
  FormControl,
  Select,
  Button,
} from "@material-ui/core/";
import { GenerateQuestion } from "../question-generator";
import * as questionTypes from "../question-types";
import DataContext from "../../DataContext";

interface IProps {
  data: OrgInfoQuestion[];
  submitOrgInfo: ()=> void;

}
async function putData(url: string, data = {}): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
export const OrgInfoContent: React.FC<IProps> = (props: IProps) => {
  const context=  useContext(DataContext);
  const orgInfo = context.orgInfo;
  const orgInfoAnswers = context.orgInfoAnswers;
  const [answers, setAnswers] = React.useState<{
    [questionChoiceId: string]: {
      questionId: string;
      choice: string;
      answer: string;
    };
  }>({});
  const [render, reRender] = useState<boolean>(false);
  const [companyName, setCompanyName] = React.useState<string>(
    orgInfo.company_name
  );
  const [address, setAddress] = React.useState<string>(orgInfo.address);
  const [postcode, setPostcode] = React.useState<string>(orgInfo.postcode);

  function putAnswerCallback(id: number, choice: string, answer: string) {
    const existingAnswers = answers;
    existingAnswers[id.toString() + choice] = {
      questionId: id.toString(),
      choice: choice,
      answer: answer,
    };
    setAnswers(existingAnswers);
    const contextAnswers = context.orgInfoAnswers
    var foundAnswer = contextAnswers.find((x)=>x.questionId===id&&x.choice===choice);
    if(foundAnswer){
      contextAnswers.map((x)=>{
        if(x.questionId===id && x.choice===choice){
          var newAnswer = x;
          newAnswer.answer = answer;
          return newAnswer;
        }else{
          return x;
        }
      });
    }else{

      contextAnswers.push({  id: -1,
        questionId: id,
        user_id: context.userId,
        city_council_id: 0,
        choice: choice,
        answer: answer,
        year: 2021});
    }
    
    context.setOrgInfoAnswers(contextAnswers);
    reRender(!render);
  }
  function saveAnswers() {
    putData("https://greencityapi-new.absolarlab.com/api/OrgInfo/", {
      city_council_id: 0,
      user_id: context.userId,
      company_name: companyName,
      address: address,
      postcode: postcode,
      types: [],
    });
    if (Object.keys(answers).length > 0) {
      Object.keys(answers).forEach((questionChoiceId: string) => {
        putData(
          "https://greencityapi-new.absolarlab.com/api/Answer/orginfo/" +
            answers[questionChoiceId].questionId,
          {
            choice: answers[questionChoiceId].choice,
            answer: answers[questionChoiceId].answer,
            user_id: context.userId,
            city_council_id: 0,
            year: 2021,
          }
        );
      }); 
    }
    props.submitOrgInfo();
  }
  return (
    <div className="content_container">
      <h4 className="org_h4">COMPANY INFORMATION</h4>
      <Grid
        container
        spacing={2}
        alignItems="center"
        className="form_row"
        justify="flex-start"
      >
        <Grid item xs={2}>
          Company name:
        </Grid>
        <Grid item xs={10}>
          <TextField
            value={companyName}
            onChange={(e) => {
              setCompanyName(e.target.value);
            }}
            size="small"
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={2}>
          Address:
        </Grid>
        <Grid item xs={10}>
          <TextField
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
            size="small"
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={2}>
          Postcode:
        </Grid>
        <Grid item xs={10}>
          <TextField
            value={postcode}
            onChange={(e) => {
              setPostcode(e.target.value);
            }}
            size="small"
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={2}>
          <div>Organisation type (please indicate all that apply) :</div>
        </Grid>
        <Grid item xs={10}>
          <Grid container justify="space-evenly">
            <Grid item xs={2} className="org_type_name">
              Charity
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
            <Grid item xs={2} className="org_type_name">
              Education
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
            <Grid item xs={2} className="org_type_name">
              Sole Trader
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
            <Grid item xs={2} className="org_type_name">
              Micro, Small or Medium Enterprise
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
            <Grid item xs={2} className="org_type_name">
              Government body
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
            <Grid item xs={2} className="org_type_name">
              Limited Company / PLC
            </Grid>
            <Grid item xs={2} className="org_type_tick">
              <Checkbox style={{ color: "#44B8A8" }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <h4 className="org_h4">BUILDING PORTFOLIO</h4>
      <Grid container spacing={2} className="form_row" alignItems="center">
        {props.data.map((questionData) => {
          var numberOfAnswers = 1;
          var show = true;
          questionData.modifiers.forEach((modifier)=>{
            if(modifier.questionModifier=="multiply"){
              var matchingRequirementAnswer = orgInfoAnswers.find((x)=>x.questionId === modifier.questionModifierId);
              if(matchingRequirementAnswer){
                try{
                  numberOfAnswers = parseInt(matchingRequirementAnswer.answer);
                }catch {
                  show = false; 
                }
              }
            }else if(modifier.questionModifier=="required"){
              var matchingRequirementAnswer = orgInfoAnswers.find((x)=>x.questionId === modifier.questionModifierId);
              if(!matchingRequirementAnswer){
                show = false;
              }
            }
          });
          if(show && numberOfAnswers > 0){
            return (
              Array(numberOfAnswers).fill(1).map((x, index)=>{
                return(
              <GenerateQuestion
                    key={questionData.id}
                    question={questionData.question}
                    help={questionData.help}
                    type={questionData.type}
                    choices={questionData.choices}
                    id={questionData.id}
                    putAnswerCallback={putAnswerCallback}
                    carbonQuestion={false}
                    orgInfoQuestion={true}
                    index={index+1}
                  />
                );
              })
              
            );
          }else{
            return null;
          }
          
        })}
      </Grid>
      <Button
        id="consent_button"
        onClick={() => {
          saveAnswers();
        }}
      >
        Submit
      </Button>
    </div>
  );
};
